module.exports = __webpack_public_path__ + "static/media/duolingo.0a5e1433.svg";